const initialState = {
    navbarButtons: []
}

const reducer = (state = initialState, action) => {

    if (action.type === 'changeNavbarButtons') {
        return {
            ...state,
            navbarButtons: action.navbarButtons
        }
    }

    return state;
}

export default reducer;